import { useP2GMediaQueryOnly } from '@parcel2go/core-ui';
import { Outlet } from 'react-router-dom';
import Navvy from './navvy';
import { NavSmartActions } from '~/components/nav/nav-smart-actions';
import useSmartNav from '~/hooks/use-smart-nav';
import DesktopTitledLayout from './desktop-layout';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import RequireCustomer from './require-customer';
import { Suspense, useMemo } from 'react';
import MobileLayout from './mobile-layout';
import { sanitisedRoutesOfRewards } from '~/routes/groups/rewards';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';

export default function Component() {
  const isXs = useP2GMediaQueryOnly('xs');
  const { showSmartActions } = useSmartNav();
  const { t } = useTranslation(TranslationNamespaces.REWARDS);
  const rewardsRoutes = useMemo(() => sanitisedRoutesOfRewards(), []);

  const title = useMemo(() => {
    // Only add the "Refer and " prefix if the Referrals feature is enabled, otherwise just show "Rewards"
    if (rewardsRoutes.includes(RoutingConstants.Referrals)) {
      return t('REWARDS_AND_REFERRALS_AREA_TITLE', { defaultValue: 'Refer and Get Rewarded' });
    }
    return t('REWARDS_AREA_TITLE', { defaultValue: 'Rewards' });
  }, [t, rewardsRoutes]);

  if (isXs) {
    return (
      <MobileLayout>
        {showSmartActions && (
          <Suspense>
            <RequireCustomer isXs={isXs} silent={true}>
              <NavSmartActions isXs={isXs} wrapper={(x) => <>{x}</>} contained={false} />
            </RequireCustomer>
          </Suspense>
        )}
        <Outlet />
      </MobileLayout>
    );
  }

  return (
    <DesktopTitledLayout title={title}>
      <Suspense>
        <Navvy routes={rewardsRoutes} prefix="REWARDS" />
      </Suspense>
      {showSmartActions && (
        <Suspense>
          <RequireCustomer isXs={isXs} silent={true}>
            <NavSmartActions isXs={isXs} wrapper={(x) => <>{x}</>} contained={false} />
          </RequireCustomer>
        </Suspense>
      )}
      <Outlet />
    </DesktopTitledLayout>
  );
}

Component.displayName = 'Rewards';
